/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid, Grid } from "frontend/src/components/Layout"
import { CMSLink } from "frontend/src/components/CMSLink"

function TextContentDesktop({ title, text, buttonText, buttonURL }) {
  return (
    <Grid columns="2fr 1fr" gap="20px" sx={{ py: 8, display: ["none", "none", "grid"] }}>
      <div sx={{ gridColumn: "1 / span 1" }}>
        <h2
          sx={{
            color: "background",
            fontSize: ["5.6964vw", "22.7856px", "2.470608vw", "29.7216px"],
            lineHeight: ["5.75vw", "23px", "2.9925vw", "36px"],
            mb: 4,
          }}
        >
          {title}
        </h2>
        <p
          sx={{
            color: "background",
            fontSize: ["3.9628vw", "15.8512px", "1.317631vw", "15.8512px"],
            lineHeight: ["6.5vw", "26px", "2.16125vw", "26px"],
          }}
        >
          {text}
        </p>
      </div>
      <div sx={{ gridColumn: "2 / span 1" }}>
        <CMSLink
          sx={{
            backgroundColor: "background",
            color: "almostBlack",
            fontWeight: 700,
            width: ["61.75vw", "247px", "20.531875vw", "247px"],
            display: "inline-block",
            textAlign: "center",
            borderRadius: "41px",
            height: ["9.5vw", "38px", "3.15875vw", "38px"],
            lineHeight: ["9.5vw", "38px", "3.15875vw", "38px"],
            fontSize: ["4.9536vw", "19.8144px", "1.647072vw", "19.8144px"],
            my: 4,
          }}
          link={{
            externalUrl: buttonURL,
            follow: false,
            newtab: false,
            event: "anchorClick",
            destination: "offerSection",
            pageType: "LandingPage",
            section: "footer",
          }}
        >
          {buttonText}
        </CMSLink>
      </div>
    </Grid>
  )
}

function TextContentMobile({ title, text, buttonText, buttonURL }) {
  return (
    <div sx={{ py: 8, display: ["block", "block", "none"], mx: "auto", maxWidth: "400px" }}>
      <div sx={{ mb: 6 }}>
        <h2
          sx={{
            color: "background",
            fontSize: ["5.6964vw", "22.7856px", "2.470608vw", "29.7216px"],
            lineHeight: ["5.75vw", "23px", "2.9925vw", "36px"],
            mb: 5,
            textAlign: "center",
          }}
        >
          {title}
        </h2>
        <p
          sx={{
            color: "background",
            fontSize: ["3.9628vw", "15.8512px", "1.317631vw", "15.8512px"],
            lineHeight: ["6.5vw", "26px", "2.16125vw", "26px"],
            textAlign: "center",
          }}
        >
          {text}
        </p>
      </div>
      <div sx={{ textAlign: "center" }}>
        <CMSLink
          sx={{
            backgroundColor: "background",
            color: "almostBlack",
            fontWeight: 700,
            width: ["61.75vw", "247px", "20.531875vw", "247px"],
            display: "inline-block",
            textAlign: "center",
            borderRadius: "41px",
            height: ["9.5vw", "38px", "3.15875vw", "38px"],
            lineHeight: ["9.5vw", "38px", "3.15875vw", "38px"],
            fontSize: ["4.9536vw", "19.8144px", "1.647072vw", "19.8144px"],
            my: 4,
          }}
          link={{
            externalUrl: buttonURL,
            follow: false,
            newtab: false,
            event: "anchorClick",
            destination: "offerSection",
            pageType: "LandingPage",
            section: "footer",
          }}
        >
          {buttonText}
        </CMSLink>
      </div>
    </div>
  )
}

function TextContent({ title, text, buttonText, buttonURL }) {
  return (
    <SectionGrid
      sx={{
        backgroundColor: "almostBlack",
        height: ["66.75vw", "267px", "15.46125vw", "186px"],
      }}
    >
      <SectionGrid.narrow>
        <TextContentDesktop
          title={title}
          text={text}
          buttonText={buttonText}
          buttonURL={buttonURL}
        />
        <TextContentMobile
          title={title}
          text={text}
          buttonText={buttonText}
          buttonURL={buttonURL}
        />
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { TextContent }
